<!-- 公共弹窗 -->
<template>
  <div class='v-dalog'>
    <van-popup v-model="isShowDalog" :close-on-click-overlay="false" style='border-radius:10px;' >
      <div class="dalog-box">
        <div class="dalog-content">
          <div class="dalog-title">{{dalogTitle}}</div>
          <p :style="{'text-align':isCenter?'center':''}">{{dalogContent}}</p>
        </div>
        <div class="line"></div>
        <div class="btn-box df-between" v-if='isShowTwoButton'>
          <div class="btn btn-gray df-center" @click='handleBtnLeft' >{{dalogBtn1}}</div>
          <div class="btn df-center" @click='handleBtnRight' >{{dalogBtn2}}</div>
        </div>
        <div class="btn-box df-between" v-else>
          <div class="btn df-center" @click='handleOk' >{{dalogBtn3}}</div>
        </div>
        <div class="close-dalog" @click='handleClosePopup' v-if='isShowCloseDalog' >
          <i class="iconfont icon-close"></i>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    props:{
      isShowDalog:{
        type:Boolean,
        default:false
      },
      isShowCloseDalog:{// 是否显示关闭按钮
        type:Boolean,
        default:false
      },
      isShowTwoButton:{// 是否显示双按钮
        type:Boolean,
        default:false
      },
      dalogContent:{// 提示内容
        type:String,
        default:''
      },
      isCenter:{// 是否居中显示
        type:Boolean,
        default:false
      },
      isColor:{// 按钮颜色
        type:String,
        default:''
      },
      dalogTitle:{// 标题title
        type:String,
        default:'提示'
      },
      dalogBtn1:{// 按钮1名称
        type:String,
        default:'取消'
      },
      dalogBtn2:{// 按钮2名称
        type:String,
        default:'确认'
      },
      dalogBtn3:{// 按钮3名称
        type:String,
        default:'知道了'
      },
    },
    data() {
      return {}
    },
    created() {},
    methods: {
      handleBtnLeft(){
        this.$emit('handleBtnLeft')
      },
      handleBtnRight(){
        this.$emit('handleBtnRight')
      },
      handleOk(){
        this.$emit('handleOk')
      }
    },
  }
</script>
<style lang='scss' scoped>
  .dalog-box {
    position: relative;
    width: 310px;
    background-color: #fff;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    border-radius: 10px;
    overflow: hidden;
    .dalog-content {
      padding: 24px;
      border-bottom: 1px solid #eee;
      .dalog-title {
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        margin-bottom: 10px;
        text-align: center;
      }
      p {
        font-size: 14px;
        color: #666;
      }
    }
    .btn-box {
      color: #26b4ff;
      .btn {
        flex: 1;
        padding: 12px 0px;
      }
      .btn-gray {
        color: #323233;
        border-right: 1px solid #eee;
      }
    }
    .close-dalog {
      position: absolute;
      top: 0px;
      right: 0px;
      padding: 10px;
      .icon-close {
        font-size: 18px;
      }
    }
  }
</style>